import { defineStore } from 'pinia'

export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    show: false,
    message: '',
    color: 'success',
    timeout: 3000
  }),
  actions: {
    open({ message, color = 'success', timeout = 3000 }) {
      this.message = message
      this.color = color
      this.timeout = timeout
      this.show = true
    },
    success(message, timeout = 3000) {
      this.open({ message, color: 'success', timeout })
    },
    error(message, timeout = 4000) {
      this.open({ message, color: 'error', timeout })
    },
    close() {
      this.show = false
    }
  }
})
